export const ADD_FAVORITE_START = 'ADD_FAVORITE_START';
export const ADD_FAVORITE_SUCCESS = 'ADD_FAVORITE_SUCCESS';
export const ADD_FAVORITE_ERROR = 'ADD_FAVORITE_ERROR';
export const CLEAR_FAVORITE_ERROR = 'CLEAR_FAVORITE_ERROR';

export const DELETE_FAVORITE_START = 'DELETE_FAVORITE_START';
export const DELETE_FAVORITE_SUCCESS = 'DELETE_FAVORITE_SUCCESS';
export const DELETE_FAVORITE_ERROR = 'DELETE_FAVORITE_ERROR';
export const API_FAVORITED_INIT = 'API_FAVORITED_INIT';
export const API_FAVORITED_SUCCESS = 'API_FAVORITED_SUCCESS';
